import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|Enrollment|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryEnrollment';
export type SPCandidateHistoryEnrollmentLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpireDate`
	| `${LocNameStart}LabelUpdated`
	| `${LocNameStart}LabelReviewStatus`
	| `${LocNameStart}LabelInvalid`
	| `${LocNameStart}LabelDataProvider`
	| `${LocNameStart}LabelDocumentation`;

export const spCandidateHistoryEnrollmentLocs: LocDefs<SPCandidateHistoryEnrollmentLocNames> = {
	SPCandidateHistoryEnrollmentTitleTab: {
		defaultValue: 'Enrollment',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Candidates.Enrollment.Title.Tab',
		...sharedProperties,
	},
	SPCandidateHistoryEnrollmentTitlePage: {
		defaultValue: 'Enrollment',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Candidates.Enrollment.Title.Enrollment',
		...sharedProperties,
	},
	SPCandidateHistoryEnrollmentLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Enrollment.ColumnHeading.Name',
		...sharedProperties,
	},
	SPCandidateHistoryEnrollmentLabelActiveDate: {
		defaultValue: 'Active Date',
		description: 'Column heading for: Active Date.',
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Enrollment.ColumnHeading.ActiveDate',
		...sharedProperties,
	},
	SPCandidateHistoryEnrollmentLabelExpireDate: {
		defaultValue: 'Expire Date',
		description: 'Column heading for: Expire Date.',
		displayPath: `${pathStart}Expire Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Enrollment.ColumnHeading.ExpireDate',
		...sharedProperties,
	},
	SPCandidateHistoryEnrollmentLabelUpdated: {
		defaultValue: 'Updated',
		description: 'Column heading for: Updated.',
		displayPath: `${pathStart}Updated`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Enrollment.ColumnHeading.Updated',
		...sharedProperties,
	},
	SPCandidateHistoryEnrollmentLabelReviewStatus: {
		defaultValue: 'Review Status',
		description: 'Column heading for: Review Status.',
		displayPath: `${pathStart}Review Status`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Enrollment.ColumnHeading.ReviewStatus',
		...sharedProperties,
	},
	SPCandidateHistoryEnrollmentLabelInvalid: {
		defaultValue: 'Invalid',
		description: 'Column heading for: Invalid.',
		displayPath: `${pathStart}Invalid`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Enrollment.ColumnHeading.Invalid',
		...sharedProperties,
	},
	SPCandidateHistoryEnrollmentLabelDataProvider: {
		defaultValue: 'Data Provider',
		description: 'Column heading for: Data Provider.',
		displayPath: `${pathStart}Data Provider`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Enrollment.ColumnHeading.DataProvider',
		...sharedProperties,
	},
	SPCandidateHistoryEnrollmentLabelDocumentation: {
		defaultValue: 'Documentation',
		description: 'Column heading for: Documentation.',
		displayPath: `${pathStart}Documentation`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Enrollment.ColumnHeading.Documentation',
		...sharedProperties,
	},
};

export type SPCandidateHistoryEnrollmentLocType = LocMap<SPCandidateHistoryEnrollmentLocNames>;
